import styled from 'styled-components';
import { applySX, htmlToText, Show, type WithSX } from '@elfsight/lib-utils';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { isInlineLayout } from '../../../utils';
import { useElements } from '../elements-context';
import { ElementBase } from './element-base';

const COMPACT_MODE_MIN_WIDTH_EM = 20;
const COMPACT_MODE_MAX_WIDTH_EM = 40;
const COMPACT_LETTERS_BREAKPOINT = 50;

export function Heading() {
  const { layout } = useSettings();
  const {
    heading: { text }
  } = useElements();
  const sanitizedText = htmlToText(text);
  const isBar = !isInlineLayout(layout);
  const isCompactMode =
    isBar && sanitizedText.length >= COMPACT_LETTERS_BREAKPOINT;

  const sx = (() => {
    if (isCompactMode) {
      return {
        maxWidth: `${COMPACT_MODE_MAX_WIDTH_EM}em`,
        minWidth: `${COMPACT_MODE_MIN_WIDTH_EM}em`
      };
    }

    if (isBar) {
      return {
        whiteSpace: 'nowrap'
      };
    }

    return {};
  })();

  return (
    <Show when={!!text}>
      <Text dangerouslySetInnerHTML={{ __html: text }} $sx={sx} />
    </Show>
  );
}

const Text = styled(ElementBase).attrs<WithSX>(
  ({
    theme: {
      heading: { color, fontSize }
    }
  }) => ({
    color,
    as: Typography,
    className: createReadableClass({ component: 'element-heading' }),
    textStyle: {
      fontSize
    }
  })
)`
  ${applySX};
`;
